export const CREDITLIMTS = "CREDITLIMTS";
export const CREDITLIMT_COUNT = "CREDITLIMT_COUNT";
